<template>
  <div class="customer-common">
    <div>
      <b-form-group>
        <label>Điện thoại:<b class="text-danger">*</b> </label>
        <i
          v-show="customerModel.customerId"
          @click="showPopoverCustomer = !showPopoverCustomer"
          @keydown.enter="showPopoverCustomer = !showPopoverCustomer"
          class="far fa-caret-square-down text-warning ml-2"
          id="popover-button-sync"
          role="button"
          tabindex="0"
          style="cursor: pointer"
        ></i>
        <Autosuggest
          :model="customerModel.customerMobile"
          :suggestions="filteredOptionsCustomer"
          :suggestionName="'phoneNumber'"
          placeholder="số điện thoại"
          :limit="10"
          @select="onSelectCustomer"
          @change="onSearchChange"
        >
          <template #custom="{ suggestion }">
            <div>
              <div class="d-flex flex-column">
                <span
                  class="text-primary mb-1"
                  v-if="suggestion.item.phoneNumber"
                  >({{ suggestion.item.phoneNumber }})</span
                >
                <span v-if="suggestion.item.fullName">{{
                  suggestion.item.fullName
                }}</span>
                <span v-else>{{ suggestion.item.message }}</span>
              </div>
            </div>
          </template>
        </Autosuggest>
        <b-form-invalid-feedback
          :state="validateCustomer"
          id="input-phone-live-feedback"
          >Vui lòng nhập số điện thoại hợp lệ!</b-form-invalid-feedback
        >
      </b-form-group>
      <b-form-group>
        <div class="type-appellation">
          <div class="appellation">
            <label for="input-name"
              >Danh xưng:<b class="text-danger">*</b>
            </label>
            <label class="d-none">{{ customerModel }}</label>
            <treeselect
              :options="appellationOptions"
              v-model="customerModel.customerAppellation"
              :multiple="false"
              placeholder="Chọn danh xưng"
              noResultsText="Không có kết quả"
              :clearable="false"
              size="sm"
            ></treeselect>
          </div>
          <!-- <div class="type">
            <label for="input-name"> Loại khách: </label>
            <treeselect
              :options="optionsCustomerType"
              :multiple="false"
              placeholder="Chọn loại khách"
              noResultsText="Không có kết quả"
              :match-keys="['label', 'custom']"
              v-model="customerModel.customerType"
              :clearable="false"
              openDirection="bottom"
            >
            </treeselect>
          </div> -->
        </div>
      </b-form-group>
      <b-form-group>
        <label>
          Họ và tên:<b class="text-danger">*</b>
          <!-- <span class="text-primary" v-html="pointText"></span> -->
        </label>
        <b-form-input
          class="input-style"
          size="sm"
          type="text"
          v-model="customerModel.customerName"
          placeholder="Tên khách hàng"
        ></b-form-input>
      </b-form-group>
      <b-form-group>
        <label>Email:</label>
        <b-form-input
          class="input-style"
          size="sm"
          type="email"
          v-model="customerModel.customerEmail"
          placeholder="Email khách hàng"
        ></b-form-input>
      </b-form-group>
      <b-form-group>
        <label>
          Ngày sinh:<b class="text-danger" v-if="requireDateOfBirth">*</b>
        </label>
        <b-form-input
          class="input-style"
          size="sm"
          type="date"
          v-model="customerModel.customerDateOfBirth"
          :state="validateDateOfBirth"
        ></b-form-input>
        <b-form-invalid-feedback
          v-if="requireDateOfBirth && validateDateOfBirth === false"
          >Vui lòng nhập ngày sinh!</b-form-invalid-feedback
        >
      </b-form-group>

      <b-form-group>
        <label>Tỉnh/Thành phố:</label>
        <treeselect
          v-model="selectedProvince"
          :options="provinceOptions"
          :multiple="false"
          :placeholder="'Chọn tỉnh/thành phố'"
          :cache-options="false"
          :normalizer="normalizer"
          :disabled="isLoadingCustomer"
          retryText="Thử lại..."
          retryTitle="Nhấp thử lại"
          searchPromptText="Nhập để tìm kiếm..."
          loadingText="Đang tải..."
          noResultsText="Không có kết quả"
          openDirection="bottom"
          size="sm"
        ></treeselect>
      </b-form-group>
      <b-form-group>
        <label>Xã/Phường:</label>
        <treeselect
          v-model="selectedWard"
          :options="wardOptions"
          :multiple="false"
          :placeholder="'Chọn xã/phường'"
          :cache-options="false"
          :normalizer="normalizer"
          :disabled="!selectedProvince || isLoadingCustomer"
          retryText="Thử lại..."
          retryTitle="Nhấp thử lại"
          searchPromptText="Nhập để tìm kiếm..."
          loadingText="Đang tải..."
          noResultsText="Không có kết quả"
          openDirection="bottom"
          size="sm"
        ></treeselect>
      </b-form-group>
      <b-form-group>
        <label>Địa chỉ chi tiết:</label>
        <b-form-textarea
          :value="displayAddress"
          size="sm"
          class="input-style"
          :placeholder="'Số nhà, đường, thôn/xóm...'"
          :rows="6"
          :max-rows="6"
          :disabled="isLoadingCustomer"
          @input="onAddressInput"
        ></b-form-textarea>
      </b-form-group>
    </div>
    <div>
      <div>
        <b-popover
          :show.sync="showPopoverCustomer"
          target="popover-button-sync"
          title="Lịch sử khách hàng"
          triggers="hover focus"
          id="popover-customer"
        >
          <div>
            <a
              @click="copyCustomerMobile"
              class="mt-1 d-block"
              v-if="customerModel.customerMobile.length > 8"
              ><b class="text-dark">Số điện thoại :</b>
              {{ customerModel.customerMobile }}
              <i
                class="far fa-copy text-primary cursor-pointer ml-1"
                style="font-size: 0.85rem"
              ></i>
            </a>
            <a href="#" class="mt-1 d-block"
              ><b class="text-dark">Đơn hàng :</b>
              {{ customerTransaction.orderCount }}</a
            >
            <a href="#" class="mt-1 d-block"
              ><b class="text-dark">Bán lẻ :</b>
              {{ customerTransaction.retailCount }}</a
            >
            <a href="#" class="mt-1 d-block"
              ><b class="text-dark">Bán buôn:</b>
              {{ customerTransaction.wholesaleCount }}</a
            >
            <a href="#" class="mt-1 d-block"
              ><b class="text-dark">Trả hàng:</b>
              {{ customerTransaction.refundCount }}</a
            >
          </div>
          <div class="mt-3 text-center">
            <span class="text-link" @click="viewCustomerTransaction"
              >Chi tiết</span
            >
          </div>
        </b-popover>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import AddressService from '@/core/api/address/address.service';
import { CUSTOMER_TYPE } from '@/utils/constants';
import { cloneDeep } from 'lodash';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { removeAccents, copyClipBoard, makeToastFaile } from '@/utils/common';
import { mapGetters } from 'vuex';
import { SET_CUSTOMER_ORDER_INFO } from '@/core/services/store/modules/order/order-customer-info.module.js';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import { TIME_TRIGGER } from '@/utils/constants';
import decounce from 'debounce';

export default {
  props: {
    onSubmiting: Boolean,
    billData: Object,
    fromOrder: Boolean,
    action: String,
    requireDateOfBirth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      provinceOptions: [],
      wardOptions: [],
      selectedProvince: null,
      selectedWard: null,
      detailAddress: '',
      isLoadingWards: false,
      selectedCustomerSource: null,
      listCustomerSource: [],
      customerModel: {
        customerId: null,
        customerMobile: '',
        customerName: '',
        customerLastName: '',
        customerAddress: '',
        customerType: 1,
        customerAppellation: null,
        customerEmail: '',
        customerDateOfBirth: null,
        totalPoint: 0,
        wardId: null,
      },
      optionsCustomerType: [],
      appellationOptions: [
        { id: null, label: 'Chọn danh xưng' },
        { id: 1, label: 'Anh' },
        { id: 2, label: 'Chị' },
        { id: 3, label: 'Khác' },
      ],
      showPopoverCustomer: false,
      defaultOptionCustomers: null,
      skipLoaded: false,
      isOpenCustomerSearch: false,
      customerTransaction: {
        orderCount: 0,
        retailCount: 0,
        wholesaleCount: 0,
        refundCount: 0,
      },
      filteredOptionsCustomer: [],
      optionsCustomer: [],
      isLoadingCustomer: false,
    };
  },
  components: {
    Treeselect,
    Autosuggest,
  },
  async created() {
    this.mappingEnum();
    this.debouncedSync = decounce(this.syncCustomerData, 300);

    try {
      // Load provinces first
      await this.loadProvinces();

      if (this.action === 'update') {
        const customerModel = this.getOrderCustomerInfo;
        this.defaultOptionCustomers = [
          {
            id: customerModel.customerId,
            label: customerModel.customerMobile,
            customLabel: customerModel.customerName,
          },
        ];
        this.customerModel = customerModel;
        await this.loadCustomerData(this.customerModel.customerId, true);
      }
    } catch (error) {
      console.error('Error during component creation:', error);
      makeToastFaile('Không thể tải dữ liệu khởi tạo');
    }

    this.$nextTick(() => {
      this.skipLoaded = true;
    });
  },
  async mounted() {
    if (!this.fromOrder) {
      this.customerModel = cloneDeep(this.billData.customerModel);
      await this.loadCustomerData(this.customerModel.customerId, true);
    }
  },
  computed: {
    ...mapGetters(['getOrderCustomerInfo']),
    validateCustomer() {
      if (!this.onSubmiting) {
        return true;
      }

      if (
        !this.customerModel.customerMobile ||
        this.customerModel.customerMobile.trim().length < 8 ||
        this.customerModel.customerMobile.trim().length > 15
      ) {
        return false;
      }

      return true;
    },
    validateDateOfBirth() {
      if (!this.onSubmiting) {
        return null;
      }

      if (this.requireDateOfBirth) {
        return !!this.customerModel.customerDateOfBirth;
      }

      return null;
    },
    pointText: {
      get() {
        return `<b>(Tổng điểm: ${this.customerModel.totalPoint || 0})</b>`;
      },
      set(newValue) {
        return newValue ? newValue : '';
      },
    },
    displayAddress() {
      return this.detailAddress || this.customerModel.customerAddress || '';
    },
  },
  watch: {
    'customerModel.customerMobile': function (newValue) {
      if (this.skipLoaded) {
        if (!newValue) {
          this.pointText = null;
        }
      }
    },
    customerModel: {
      handler: function () {
        if (this.skipLoaded) {
          this.debouncedSync();
        }
      },
      deep: true,
    },
    selectedProvince: async function (newValue, oldValue) {
      if (this.skipLoaded && oldValue !== undefined && newValue !== oldValue) {
        await this.onProvinceChange(newValue);
      }
    },
    selectedWard: async function (newValue) {
      if (this.skipLoaded && newValue) {
        this.customerModel.wardId = newValue;
        this.syncCustomerData();
      }
    },
  },
  methods: {
    debounceInput: decounce(function () {
      this.getListCustomer();
    }, TIME_TRIGGER),
    mappingEnum() {
      this.optionsCustomerType = cloneDeep(CUSTOMER_TYPE).reduce(
        (result, element) => {
          if (element.value !== null) {
            result.push({
              id: element.id,
              label: element.name,
              custom: removeAccents(element.name),
            });
          }
          return result;
        },
        [],
      );
    },
    copyCustomerMobile() {
      const customerMobile = this.customerModel.customerMobile || '';
      if (customerMobile.length > 8) {
        copyClipBoard(customerMobile, 'Số điện thoại');
      }
    },
    async onSelectCustomer(option) {
      if (option.item && option.item.id) {
        // Clear address data before loading new customer
        this.selectedProvince = null;
        this.selectedWard = null;
        this.wardOptions = [];
        this.detailAddress = '';
        this.customerModel.wardId = null;

        this.customerModel.customerId = option.item.id;
        this.customerModel.customerMobile = option.item.phoneNumber;
        this.customerModel.customerAppellation = option.item.gender;

        await this.loadCustomerData(option.item.id);
      } else {
        // Clear all customer and address data
        this.customerModel.customerId = '';
        this.customerModel.customerMobile = option.item.phoneNumber;
        this.customerModel.customerName = '';
        this.customerModel.totalPoint = 0;
        this.customerModel.customerEmail = '';
        this.customerModel.customerDateOfBirth = null;
        this.selectedProvince = null;
        this.selectedWard = null;
        this.wardOptions = [];
        this.detailAddress = '';
        this.customerModel.wardId = null;
      }
    },
    onSearchChange(searchQuery) {
      if (!searchQuery) {
        searchQuery = '';
      }
      this.customerModel.customerMobile = searchQuery;
      this.optionsCustomer = [];
      this.filteredOptionsCustomer = [...this.optionsCustomer];
      this.debounceInput();
    },
    async getListCustomer() {
      const text = this.customerModel.customerMobile
        ? this.customerModel.customerMobile.trim()
        : null;
      if (!text) {
        return;
      }

      try {
        const data = await ApiService.get(
          `customers/get-by-phone?phoneNumber=${text}`,
        );

        this.optionsCustomer = data.data.data;
        if (this.optionsCustomer.length > 0) {
          this.filteredOptionsCustomer = [...this.optionsCustomer];
        } else {
          this.filteredOptionsCustomer = [
            { message: 'SĐT không có trong hệ thống', phoneNumber: text },
          ];
        }
      } catch (error) {
        console.error('Error fetching customer list:', error);
        this.filteredOptionsCustomer = [
          { message: 'Lỗi khi tìm kiếm', phoneNumber: text },
        ];
      }
    },
    async loadOptionCustomers({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        this.customerModel.customerMobile = searchQuery;

        try {
          const result = await this.fetchCustomers(searchQuery);

          let optionCustomers = [];
          if (result.data.length) {
            optionCustomers = (result.data || []).map((element) => {
              return {
                id: element.id,
                label: element.phoneNo,
                customLabel: element.fullName,
              };
            });
          } else {
            optionCustomers = [
              {
                id: -1,
                label: searchQuery,
                customLabel: 'SĐT không có trong hệ thống',
                notFound: true,
              },
            ];
          }
          callback(null, optionCustomers);
        } catch (error) {
          console.error('Error loading option customers:', error);
          callback(error, []);
        }
      }
    },
    async fetchCustomers(searchQuery) {
      const textInput = searchQuery ? searchQuery.trim() : null;

      if (!textInput) {
        return { data: [] };
      }

      const params = {
        phoneNumber: textInput,
      };

      try {
        const response = await ApiService.query(`customers/get-by-phone`, {
          params,
        });
        return response.data;
      } catch (error) {
        console.error('Error fetching customers:', error);
        throw error;
      }
    },

    // Centralized sync function
    syncCustomerData() {
      if (!this.skipLoaded) return;

      const customerData = {
        ...this.customerModel,
        customerAddress:
          this.detailAddress || this.customerModel.customerAddress,
        wardId: this.selectedWard,
        detailAddress: this.detailAddress,
      };
      this.$store.dispatch(SET_CUSTOMER_ORDER_INFO, customerData);
      this.$emit('onUpdate', customerData);
    },

    // Extract address logic to separate method
    async fillAddressFromData(addressData) {
      // Reset first
      this.selectedProvince = null;
      this.selectedWard = null;
      this.wardOptions = [];
      this.detailAddress = '';
      this.customerModel.wardId = null;

      if (addressData?.ward?.province?.id) {
        const provinceId = addressData.ward.province.id;
        const wardId = addressData.wardId;

        // Temporarily disable skipLoaded to prevent watcher from triggering
        const wasSkipLoaded = this.skipLoaded;
        this.skipLoaded = false;

        this.selectedProvince = provinceId;
        await this.loadWardsByProvince(provinceId, wardId);

        this.selectedWard = wardId;
        this.detailAddress = addressData.detailAddress || '';
        this.customerModel.wardId = wardId;

        this.$nextTick(() => {
          this.skipLoaded = wasSkipLoaded;
        });
      }
    },

    // Merged customer data loader
    async loadCustomerData(customerId, preserveExisting = false) {
      if (!customerId) {
        return;
      }

      this.isLoadingCustomer = true;

      try {
        const response = await ApiService.get(`customers/${customerId}`);
        const customerInfo = response.data.data;

        // Map basic info
        if (preserveExisting) {
          const customerName = this.customerModel.customerName?.trim();
          const customerAddress = this.customerModel.customerAddress?.trim();
          this.customerModel.customerName =
            customerName || customerInfo.fullName || '';
          this.customerModel.customerAddress =
            customerAddress || customerInfo.address || '';
        } else {
          this.customerModel.customerName = customerInfo.fullName || '';
          this.customerModel.customerAddress = customerInfo.address || '';
        }

        this.customerModel.customerAppellation = customerInfo.gender || null;
        this.customerModel.customerType = customerInfo.type;
        this.customerModel.totalPoint = customerInfo.totalPoint || 0;
        this.customerModel.customerLastName = customerInfo.lastName || '';
        this.customerModel.customerEmail = customerInfo.email || '';
        if (customerInfo.dateOfBirth) {
          const date = new Date(customerInfo.dateOfBirth);
          this.customerModel.customerDateOfBirth = date
            .toISOString()
            .split('T')[0];
        } else {
          this.customerModel.customerDateOfBirth = null;
        }

        // Handle address logic
        await this.fillAddressFromData(customerInfo.customerAddress);

        this.syncCustomerData();
      } catch (error) {
        console.error('Error loading customer info:', error);
        makeToastFaile('Không thể tải thông tin khách hàng');
      } finally {
        this.isLoadingCustomer = false;
      }
    },
    async getTransactionByCustomerId(customerId) {
      if (!customerId) {
        return;
      }

      try {
        const response = await ApiService.get(
          `customer/transaction/${customerId}`,
        );

        const data = response.data.data;
        this.customerTransaction.orderCount = data.orders.length;
        this.customerTransaction.retailCount = data.retails.length;
        this.customerTransaction.wholesaleCount = data.wholesales.length;
        this.customerTransaction.refundCount = data.refunds.length;
        this.$emit('fetch-customer-transaction', data);
      } catch (error) {
        console.error('Error loading customer transactions:', error);
      }
    },
    viewCustomerTransaction: function () {
      const { href } = this.$router.resolve({
        name: 'update-customer',
        query: {
          id: this.customerModel.customerId,
          phoneNo: this.customerModel.customerMobile,
        },
      });
      window.open(href, '_blank');
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },
    async loadProvinces() {
      try {
        const response = await AddressService.getProvinces();
        this.provinceOptions = response.data.data || [];
      } catch (error) {
        console.error('Error loading provinces:', error);
        makeToastFaile('Không thể tải danh sách tỉnh/thành phố');
      }
    },
    async loadWardsByProvince(provinceId, preserveWardId = null) {
      if (!provinceId) {
        this.selectedWard = null;
        this.wardOptions = [];
        return;
      }

      // Prevent duplicate API calls
      if (this.isLoadingWards) {
        return;
      }

      // Find province code from options
      const province = this.provinceOptions.find((p) => p.id === provinceId);
      if (!province) {
        console.error('Không tìm thấy tỉnh/thành phố trong danh sách');
        return;
      }

      // Store ward selection before clearing
      const previousWardId =
        preserveWardId !== null ? preserveWardId : this.selectedWard;
      if (preserveWardId === null) {
        this.selectedWard = null;
      }
      this.wardOptions = [];

      this.isLoadingWards = true;

      try {
        // Use province.code (provinceCode) for API call
        const response = await AddressService.getWardsByProvince(province.code);

        this.wardOptions = response.data.data || [];

        // Restore ward selection if it's still valid for this province
        if (
          previousWardId &&
          this.wardOptions.find((w) => w.id === previousWardId)
        ) {
          this.selectedWard = previousWardId;
          this.customerModel.wardId = previousWardId;
        }
      } catch (error) {
        console.error('Error loading wards:', error);
        makeToastFaile('Không thể tải danh sách xã/phường');
      } finally {
        this.isLoadingWards = false;
      }
    },
    async onProvinceChange(provinceId) {
      await this.loadWardsByProvince(provinceId);
    },
    onAddressInput(value) {
      this.detailAddress = value;
      this.debouncedSync();
    },
  },
};
</script>

<style scoped>
.type-appellation {
  display: flex;
  gap: 4px;
}

.border-bottom {
  border-bottom: 0.5px solid #e9e9e9;
}

.btn-group-customer-info .btn {
  padding: 0.05rem 0.05rem;
}

.vue-treeselect__input-container {
  padding-top: 0px;
}

.vue-treeselect__control {
  border-radius: 0.28rem;
  border: 1px solid #ced4da;
  height: 2.5rem;
}

.vue-treeselect--has-value .vue-treeselect__multi-value {
  margin-bottom: 2px;
}
.vue-treeselect__tip .vue-treeselect__no-results-tip {
  display: none;
}
</style>

<style lang="scss">
#popover-customer {
  .text-link:hover {
    cursor: pointer;
    color: blue;
  }
}
</style>
